import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface UserAvatarProps {
  initials: string;
  size?: number;
}

export const UserAvatar = ({ initials, size }: UserAvatarProps) => {
  return (
    <div {...stylex.props(styles.container)} style={size ? { width: size, height: size } : undefined}>
      {initials}
    </div>
  );
};
